











































































































































































































































import Component, { mixins } from 'vue-class-component';
import { currencyFormat, loadView, loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { IAutocreditAuthorizeBody, IAutocreditLedger, IOrganizations, IPaginate, IStore, IUser } from '@/types/types';
import timestamp from '@/filters/timestamp';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import DialogMixins from '@/mixins/DialogMixins';
import moment from 'moment';
import qs from 'qs';

const autocreditModule = namespace('autocredit');
const organizationModule = namespace('organizations');
const authModule = namespace('auth');

@Component({
  name: 'AutocreditPendingReview',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
    SkeletonPreloader: loadWidget('widgets/SkeletonPreloader'),
    AutocreditAuthorizeDialog: loadView('pages/products/dialogs/AutocreditAuthorizeDialog'),
  },
  filters: {
    currencyFormat,
    timestamp,
  },
})
export default class AutocreditPendingReview extends mixins(WidgetMixins, DialogMixins) {
  @autocreditModule.Getter('getReviewPendingList') reviewPendingList!: IAutocreditLedger[];
  @autocreditModule.Getter('getReviewPendingPagination') reviewPendingPagination!: IPaginate;

  @organizationModule.Getter('getAllOrganizations') organizations!: IOrganizations[];
  @authModule.Getter('getUserDetails') details!: IUser & IStore;

  options: any = {};
  query: string = '';
  businessDateMenu: boolean = false;
  // Empty selection = show review-pending entries across ALL business dates.
  businessDates: string[] = [];
  organizationId: string | null = null;
  selected: IAutocreditLedger[] = [];
  expanded: IAutocreditLedger[] = [];
  authorizeMode: 'selected' | 'day' = 'selected';

  headers: Array<{ text: string; value: string; align?: string; sortable?: boolean }> = [
    { text: 'Created', value: 'createdAt' },
    { text: 'Organization', value: 'organizationName' },
    { text: 'MSISDN', value: 'msisdn' },
    { text: 'Business Date', value: 'businessDate' },
    { text: 'Txns', value: 'transactionCount', align: 'end' },
    { text: 'Amount', value: 'amount', align: 'end' },
    { text: 'Status', value: 'status' },
    { text: '', value: 'data-table-expand' },
  ];

  get selectedTotal(): number {
    return this.selected.reduce((sum, item) => sum + (item.amount || 0), 0);
  }

  get businessDatesLabel(): string {
    const dates = [...this.businessDates].sort();
    if (dates.length === 0) return '';
    if (dates.length <= 3) return dates.join(', ');
    return `${dates[0]} — ${dates[dates.length - 1]} (${dates.length} days)`;
  }

  statusClass(status: string): string {
    const classes: { [key: string]: string } = {
      REVIEW_PENDING: 'ka-status--warning',
      PENDING: 'ka-status--info',
      PROCESSING: 'ka-status--info',
      POSTED: 'ka-status--success',
      FAILED: 'ka-status--error',
    };
    return classes[status] || 'ka-status--info';
  }

  openAuthorizeDialog(mode: 'selected' | 'day'): void {
    this.authorizeMode = mode;
    this.open('authorize');
  }

  handleAuthorize(): void {
    const body: IAutocreditAuthorizeBody = {
      authorizedBy: this.details?.email ?? this.details?.name,
      ...(this.authorizeMode === 'day'
        ? { businessDates: this.businessDates }
        : { ledgerIds: this.selected.map(({ _id }) => _id) }),
    };
    this.$store.dispatch('autocredit/authorizeReviewPending', {
      adminId: this.details?.id ?? this.details?.email,
      body,
      query: this.query,
    });
    this.selected = [];
  }

  @Watch('organizationId')
  onOrganizationIdChange(value: string): void {
    this.selected = [];
    let qParams = {
      ...qs.parse(this.query, { ignoreQueryPrefix: true }),
      organizationId: value,
    };
    this.query = qs.stringify(qParams, { skipNulls: true, addQueryPrefix: true });
    this.fetchReviewPending();
  }

  @Watch('businessDates')
  onBusinessDatesChange(dates: string[]): void {
    this.selected = [];
    const parsed = qs.parse(this.query, { ignoreQueryPrefix: true });
    delete parsed.businessDate;
    delete parsed.businessDates;
    this.query = qs.stringify(
      { ...parsed, ...(dates.length && { businessDates: dates.join(',') }) },
      { skipNulls: true, addQueryPrefix: true },
    );
    this.fetchReviewPending();
  }

  @Watch('options', { deep: true })
  onOptionsChange(paginate: IPaginate): void {
    const qParams = {
      page: paginate.page,
      limit: paginate.itemsPerPage,
      ...(this.businessDates.length && { businessDates: this.businessDates.join(',') }),
      organizationId: this.organizationId,
    };
    const query = qs.stringify(qParams, { skipNulls: true, addQueryPrefix: true });
    // The table remounts when the skeleton v-if swaps it out, re-firing this
    // watcher with unchanged options — skip identical queries to avoid a fetch loop.
    if (query === this.query) return;
    this.query = query;
    this.fetchReviewPending();
  }

  fetchReviewPending(): void {
    this.$store.dispatch('autocredit/fetchReviewPendingList', this.query);
  }

  created(): void {
    this.$store.dispatch('auth/me');
    this.$store.dispatch('organizations/list', false);
    const qParams = {
      page: 1,
      limit: 50,
    };
    this.query = qs.stringify(qParams, { skipNulls: true, addQueryPrefix: true });
    this.$store.dispatch('autocredit/fetchReviewPendingList', this.query);
  }
}
